export default {
    FULL_REDUCTION_TYPE: { // 满减类型
        1: '满金额减送',
        2: '满件数减送'
    },
    ACTIVITY_STATUS: { // 活动状态
        1: '未开始',
        2: '进行中',
        3: '已结束'
    },
    CHANNEL_TYPE: { // 渠道类型
        1: '微信',
        2: '支付宝',
        3: 'H5',
        4: '支付宝澳门'
    },
    ACTIVITY_TYPE: { // 叠加活动类型
        1: '限时秒杀',
        2: '满减邮',
        3: '限时秒杀和满减邮',
        4: '优惠券',
        5: '限时秒杀和优惠券',
        6: '满减邮和优惠券',
        7: '限时秒杀和满减邮'
    },
    ACTIVITY_STATUS_COLOR: {
        1: '#67C23A', // 未开始
        2: '#EA3D43', // 进行中
        3: '#999999', // 已结束
    }
};
